module.exports = __webpack_public_path__ + "media/images/logo-lucasistencia-a591aa7efae7da4be500ffbd730815b2.jpg";